// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__OKsfW","title":"Header_title__2KIXN","left":"Header_left__2JNOt","clinicName":"Header_clinicName__3nJWn"};